export const AppMockConstants = {
    exampleMockId: 'exampleMockId',
};
